import { HttpClient } from '@adapters/HttpClient';

export class ShopifyRedirectApiAdapter {
  private httpClient: HttpClient;

  constructor(apiClient: HttpClient) {
    this.httpClient = apiClient;
  }

  /**
   * Obtiene la URL de redirección para la instalación de Shopify.
   * La respuesta de la API es directamente la URL como texto plano.
   * @returns {Promise<string>} La URL de redirección.
   */
  public async getRedirectUrl(): Promise<string> {
    try {
      const response = await this.httpClient.get<string>(
        '/redirect/shopify/install'
      );
      // Asumimos que la respuesta directa es la URL en formato de texto
      return response as unknown as string;
    } catch (error: any) {
      console.error('Error fetching Shopify redirect URL:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to get Shopify redirect URL'
      );
    }
  }
}
